/**
 * @author xyguo
 * @description 证书中心==》证书申请管理==》批量审核
 * @Date 2020/9/17
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool} from '@/tool'
import 'antd/dist/antd.css';
import {Button} from 'antd';

let {WizContainer, modelUtils} = framework_tool;
let {WizForm, WizSelect,WizButton} = component_tool;


class BatchCheck extends WizContainer {
  componentName = "BatchCheck";

  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      ids: []
    };
    this.initTargetKeys = [];
    this.initTargetRows = [];
    this.values = {};
  }

  _componentWillMount() {
    let {initRows} = this.props;
    if (initRows && initRows()) {
      this.state.selectedRows = initRows();
      this.initTargetRows = initRows();
      initRows().forEach(data => {
        this.state.ids.push(data.id);
        this.initTargetKeys.push(data.id);
      })
    }
  }

  getSelectRows = (e) => {
    this.state.selectedRows = e;
    this.initTargetRows = e;
    this.state.ids = [];
    e.forEach(data => {
      this.state.ids.push(data.id);
      this.initTargetKeys.push(data.id);
    })
  };

  /**
   * modal框的确定按钮触发
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = (state) => {
    this.ref.validateFields((err, values) => {
      this.values = values;
      if (this.state.ids.length === 0 && !this.props.alone) {
        wizNotice.error("请选择学员");
      } else if (!err) {
        values.checkState = state;
        this._saveCertApply(values);
      }
      return
    });
  };

  /**
   * 初始化已选人员
   */
  _doInitParams = () => {
    this.onChange(this.initTargetKeys, this.initTargetRows)
  };

  onChange = (nextTargetKeys, nextTargetRows) => {
    this.setState({
      ids: nextTargetKeys,
      selectedRows: nextTargetRows
    });
  };

  propsAndStateOnChange = {
    batchUpdate: this._batchUpdate.bind(this),
  };

  _batchUpdate(nextProps, nextState) {
    if (nextProps.batchUpdate.code === 1) {
      wizNotice.success("操作成功");
      // this.doAction({
      //   path: `certApply/getListInfo`,
      //   payload: {
      //     key: `certApply@getListInfo`,
      //     apiParams: {classInfoId:this.props.classInfoId} 
      //   }
      // });
      this.props.changeModal(false, true);
      this.onChange(this.initTargetKeys, this.initTargetRows);
    } else {
      wizNotice.error(nextProps.batchUpdate.msg);
    }

  }

  /**
   * 更新 证书申请信息
   * @param values
   * @private
   */
  _saveCertApply(values) {   
    let apiPath = "certApply/batchUpdate"; //certApply
    let payloadKey = "certApply@batchUpdate";
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...values,
          ids: this.props.alone ? [this.props.record.id] :this.state.ids,
        }
      }
    });
  }

  handleClear(id) {
    id
      ? this.setState({
        selectedRows: this.state.selectedRows.filter(item => item.id !== id),
        ids: this.state.ids.filter(item => item !== id)
      })
      : this.setState({
        selectedRows: [],
        ids: []
      });
  }

  //select中的change事件
  _wizSelectOnChange(value, option) {
    //
    let classify = value.map(select => select.key)
    let selectedRows = this.state.selectedRows.filter(filter => classify.indexOf(filter.key) !== -1)
    const selectIds = [];
    selectedRows.forEach(data => {
      selectIds.push(data.id)
    })
    this.setState({
      selectedRows: selectedRows,
      ids: selectIds
    });
  }

  _renderOptions(selectedRows) {
    if (selectedRows && selectedRows.length) {
      return selectedRows.map((row, i) => this._renderOption(row))
    }
    return null
  }

  _renderOption(row) {
    if (row) {
      const fullName = row.fullName;
      return (
        <WizSelect.Option key={row.id} value={fullName} title={fullName}>
          {fullName}
        </WizSelect.Option>
      )
    }
  }

  _render() {
    const {certApplyLoading, record} = this.props;
    const ids = this.state.ids;
    let columns = [
      {
        name: "ids",
        formItem: {
          type: 'hidden',
          initialValue: {ids}
        },
      },
      this.props.alone ?
      {
        title: "账号",
        name: "userName",
        formItem: {
          initialValue: record.userName,
          disabled:true
        }
      }
      : {}
      ,
      this.props.alone ? {
        title: "姓名",
        name: "fullName",
        formItem: {
          initialValue: record.fullName,
          disabled:true
        }
      }
      : {}
      ,
      {
        title: "审核",
        name: "checkOpinion",
        formItem: {
          type: 'textarea',
          placeholder: '请输入审核意见,最多输入300个字符',
          maxlength: 200,
          rules: [],
          initialValue: this.props.alone ? record.comment : ''
        },
      }
    ];

    let onSubmit = this._saveCertApply.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: <div/>,
      formItemLayout: {
        labelCol: {span: 3},
        wrapperCol: {span: 21}
      },
      style: {maxWidth: 800}
    };
    let selectKey = this.state.selectedRows.map(selected => selected.id).join(",");
    const selectedRows = this.state.selectedRows;
    selectedRows.forEach(data => {
        data.key = data.id,
        data.label = data.fullName
    });
    const header = (
      <div style={{paddingLeft: 15, paddingBottom: 12}}>
        已选人员<strong> {selectedRows.length} </strong> {'人'}
        <Button type="link" onClick={() => this.handleClear()}>清除选择</Button>
      </div>
    );

    return (
      <div>
        
        { !this.props.alone ? <>{header} <WizSelect
          style={{width: '100%', height: 80, paddingLeft: 15}}
          key={'wizSelect_' + selectKey}
          defaultValue={this.state.selectedRows}
          labelInValue
          mode={'multiple'}
          open={false}
          onChange={(value, option) => this._wizSelectOnChange(value, option)}
        >
          {this._renderOptions(selectedRows)}
        </WizSelect></> :  <></>}
        <WizForm  {...formProps} ref={r => {
          this.ref = r;
        }}/>
        <div style={{textAlign:'center'}}>
        <WizButton type="primary" style={{ marginRight: 20 }} onClick={this._ok.bind(this,1)}>通过</WizButton>
        <WizButton type="danger"  style={{ marginLeft: 40 }} onClick={this._ok.bind(this,2)}>不通过</WizButton>
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state, ownProps) => {
  const {certApply} = state;
  const batchUpdate = modelUtils.getModelEntity(certApply, 'certApply@batchUpdate');
  return {
    batchUpdate: batchUpdate,
  };
};

const options = {withRef: true};

export default connect(mapStateToProps, null, null, options)(BatchCheck);
